export class CercaSocietaModel {
    provincia: string = "";
    localita: string = "";
    ragioneSociale: string = "";
}